module.exports = __webpack_public_path__ + "Flag-674.7524e4802ae8379c1788f90bd8281f62.svg";